module.exports = __webpack_public_path__ + "img/block5.f4e2d52c.png";